import IconItem from './icon_item';

export default class Redo extends IconItem {
  constructor() {
    super('redo', 'Ctrl+Y');
  }
}
